/**
 * Affichage du menu Finance : liste d'emails dans REACT_APP_FINANCE_ADMIN_EMAILS (séparés par des virgules).
 * Le contrôle d'accès réel est côté API (FINANCE_ADMIN_EMAILS / FINANCE_ADMIN_SECRET).
 */
export function parseFinanceAdminEmails(): string[] {
  const raw = process.env.REACT_APP_FINANCE_ADMIN_EMAILS || '';
  return raw
    .split(',')
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean);
}

export function isFinanceAdminUser(email: string | undefined | null): boolean {
  const allow = parseFinanceAdminEmails();
  if (allow.length === 0) return false;
  const e = (email || '').trim().toLowerCase();
  return Boolean(e && allow.includes(e));
}
